// 9fbef606107a605d69c0edbcd8029e5d

export const TOP_RATED = 'topRated';
export const BEST_SELLER = 'bestSeller';
export const MOST_FAVORITED = 'mostFavorited';

export const TOP_RATED_ANALYTICS_STRING = 'top rated';
export const BEST_SELLER_ANALYTICS_STRING = 'best seller';
export const MOST_FAVORITED_ANALYTICS_STRING = 'most favorited';
export const ESG_BADGE_ANALYTICS_STRING = 'esg certified';
export const ESG_BADGE_ANALYTICS_STRING_APP = 'esg';

// Zone One Badges Priority
export const PREVIOUSLY_PURCHASED_PRIORITY = 0;
export const JUST_A_FEW_LEFT_PRIORITY = 1;
export const INFLUENCER_PICKS_PRIORITY = 2;
export const BEST_SELLER_PRIORITY = 3;
export const TOP_RATED_PRIORITY = 4;
export const MOST_FAVORITED_PRIORITY = 5;
export const CLEARANCE_PRIORITY = 6;

// Zone One Badges Types
export const REGULAR_TYPE = 'regular';
export const TOP_RATED_TYPE = 'toprated';

// Zone One Badges Label
export const JUST_A_FEW_LEFT_LABEL = 'JUST A FEW LEFT!';
export const CLEARANCE_LABEL = 'CLEARANCE';

// Zone Six Badges Label
export const MATCHING_FAMILY_LABEL = 'MATCHING FAMILY';
export const GLOW_IN_THE_DARK_LABEL = 'GLOW-IN-THE-DARK';
export const ONLINE_EXCLUSIVE_LABEL = 'ONLINE ONLY';
export const NEW_BADGE_LABEL = 'NEW';
